import Vue from 'vue';
import Swal from "sweetalert2";

export function notify(message, options = {}) {
    Vue.$toast.open({
        message,
        type: 'default',
        duration: 3000,
        position: (screen.width < 992) ? 'bottom' : 'bottom-right',
        ...options,
    });
}

export function trans(langKey, replace = {}) {
    let line = window.FleetCart.langs[langKey];
    if (line === undefined || line.length === 0) {
        line = langKey;
    }

    for (let key in replace) {
        line = line.replace(`:${key}`, replace[key]);
    }

    return line;
}

export function isEmpty(value) {
    return $.isEmptyObject(value);
}

export function chunk(array, size) {
    let chunkedArray = [];
    let index = 0;

    while (index < array.length) {
        chunkedArray.push(array.slice(index, size + index));
        index += size;
    }

    return chunkedArray;
}

export function slickPrevArrow() {
    if (window.FleetCart.rtl) {
        return `<div class="arrow-prev">
                    <i class="las la-angle-right"></i> ${trans('storefront::layout.prev')}
                </div>`;
    }

    return `<div class="arrow-prev">
                <i class="las la-angle-left"></i> ${trans('storefront::layout.prev')}
            </div>`;
}

export function slickNextArrow() {
    if (window.FleetCart.rtl) {
        return `<div class="arrow-next">
                    ${trans('storefront::layout.next')} <i class="las la-angle-left"></i>
                </div>`;
    }

    return `<div class="arrow-next">
                ${trans('storefront::layout.next')} <i class="las la-angle-right"></i>
            </div>`;
}

export function getImg(path) {
    return `${window.FleetCart.baseUrl}/themes/storefront/public/images/${path}`;
}

export function getImg2(path1, path2) {
    return `${getImg(path1)} 1x, ${getImg(path2)} 2x`;
}

export function scrollToElement({element, offset}) {
    element = $(element);

    if (!element.length) return;

    let targetPosition = element.offset().top+offset;
    $('html, body').animate({ scrollTop: targetPosition }, 'fast');
}

export function formatPrice(price) {
    return price.replace(/(\.\d+)$/, (match, decimalPart) => {
        if (decimalPart === '.00') {
            return '';
        }
        return match;
    });
}

export function formatSizeString(dimension) {
    return dimension.replace(/(\d+)x(\d+)/, '$1” x $2”');
}

export const Toast= Swal.mixin({
    customClass: {
        confirmButton: "btn btn-primary",
        cancelButton: "btn btn-outline-primary"
    },
    buttonsStyling: false,
    confirmButtonText: "Close",
});
